import {FormModel} from '../forms/form-model';
import {InputModel} from '../forms/input-model';

export class ClientFormUtil {
    public static generateClientForm():FormModel {

        const inputName = new InputModel();
        inputName.type = 'text';
        inputName.label.set('en','Name');
        inputName.validation.set('required','true');
        inputName.placeholder.set('en','Client Name');
        inputName.name.set('en','ClientName');

        const inputUsername = new InputModel();
        inputUsername.type = 'text';
        inputUsername.label.set('en','Username');
        inputUsername.validation.set('required','true');
        inputUsername.placeholder.set('en','Client Username');
        inputUsername.name.set('en','ClientUsername');

        const inputPassword = new InputModel();
        inputPassword.type = 'text';
        inputPassword.label.set('en','Password');
        inputPassword.validation.set('required','true');
        inputPassword.placeholder.set('en','Client Password');
        inputPassword.name.set('en','ClientPassword');

        const form = new FormModel();
        form.title = 'New Client';
        form.inputs.push(inputName);
        form.inputs.push(inputUsername);
        form.inputs.push(inputPassword);

        return form;
    }

}
